import { useEffect } from 'react';
import { trackPageView } from '@/lib/analytics';
import { useScrollDepth } from '@/hooks/useScrollDepth';
import { useReadingTime } from '@/hooks/useReadingTime';

/** Fire a vehicle_page_view event once on mount + track scroll depth milestones + reading time. */
export function useVehiclePageView(slug: string): void {
  useEffect(() => {
    trackPageView('vehicle_seo', slug);
  }, [slug]);

  useScrollDepth('vehicle_seo', slug);
  useReadingTime(slug);
}
